export function getCurrentMonthValue(referenceDate = new Date()): string {
  const year = referenceDate.getFullYear();
  const month = String(referenceDate.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

export const AD_MONTH_OPTIONS = [
  { value: 1, label: 'January' }, { value: 2, label: 'February' }, { value: 3, label: 'March' },
  { value: 4, label: 'April' }, { value: 5, label: 'May' }, { value: 6, label: 'June' },
  { value: 7, label: 'July' }, { value: 8, label: 'August' }, { value: 9, label: 'September' },
  { value: 10, label: 'October' }, { value: 11, label: 'November' }, { value: 12, label: 'December' },
];

export const BS_MONTH_OPTIONS = [
  { value: 1, label: 'Baisakh' }, { value: 2, label: 'Jestha' }, { value: 3, label: 'Ashadh' },
  { value: 4, label: 'Shrawan' }, { value: 5, label: 'Bhadau' }, { value: 6, label: 'Ashwin' },
  { value: 7, label: 'Kartik' }, { value: 8, label: 'Mangsir' }, { value: 9, label: 'Poush' },
  { value: 10, label: 'Magh' }, { value: 11, label: 'Falgun' }, { value: 12, label: 'Chaitra' },
];

export function buildMonthLabel(monthValue: string): string {
  if (!monthValue || !/^\d{4}-\d{2}$/.test(monthValue)) {
    return '';
  }

  const [year, month] = monthValue.split('-').map((part) => Number(part));
  const monthDate = new Date(year, month - 1, 1);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
  }).format(monthDate);
  return formatted.replace(/\s+/g, '-');
}

export function buildReportDateValue(monthValue: string): string {
  if (!monthValue || !/^\d{4}-\d{2}$/.test(monthValue)) {
    return '';
  }

  return `${monthValue}-01`;
}

export function buildAccordionLabel(day: number, monthLabel: string): string {
  if (!monthLabel) {
    return `Day ${day}`;
  }

  return `Day ${day} • ${monthLabel}`;
}

export function buildDayLabel(dateValue: string): string {
  if (!dateValue || !/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return '';
  }

  const [year, month, day] = dateValue.split('-').map((part) => Number(part));
  const parsedDate = new Date(year, month - 1, day);
  const formatted = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parsedDate);
  return formatted.replace(/\s+/g, '-');
}
